import { Checkbox } from "@/components/ui/checkbox";

export const SMS_CONSENT_TEXT =
  "Customer agrees to receive text messages from APEX about this job (scheduling, status and estimate updates). " +
  "Msg & data rates may apply. Msg frequency varies. Reply STOP to opt out, HELP for help. Consent is not a condition of service.";

export const SmsConsentCheckbox = ({ checked, onChange, testId = "sms-opt-in" }) => (
  <label className="flex items-start gap-2 rounded-md border border-zinc-200 bg-zinc-50 p-2.5 cursor-pointer">
    <Checkbox checked={checked} onCheckedChange={(v) => onChange(v === true)} className="mt-0.5" data-testid={testId} />
    <span className="text-[11px] leading-relaxed text-zinc-600">{SMS_CONSENT_TEXT}</span>
  </label>
);
